import React from 'react';

import Main from './Main';
import Context from './Context';

export default function Index() {
  return (
    <Context>
      <div className="wrapper_assestment invite_wrapper">
        <Main />
      </div>
    </Context>
  );
}
